import React from "react";
import PropTypes from "prop-types";
import Select from "components/shared/Select";

class UserHighlightsFilterControl extends React.Component {
  static propTypes = {
    containerSelector: PropTypes.string,
    listItemSelector: PropTypes.string,
    listSelector: PropTypes.string
  };

  static defaultProps = {
    containerSelector: ".container",
    listItemSelector: ".user-highlight",
    listSelector: ".user-highlights"
  };

  updateFilter(filterBy) {
    const $container = $(this.props.containerSelector);
    const $list = $container.find(this.props.listSelector);
    const $listItems = $list.find(this.props.listItemSelector);

    if (filterBy) {
      $listItems.each(function () {
        $(this).toggle($(this).data("book").toString() === filterBy.toString());
      });
    } else {
      $listItems.show();
    }
  }

  onChange(option) {
    this.updateFilter(option.value);
  }

  render() {
    return (
      <Select
        {...this.props}
        baseClassName="lc-select-container--md"
        options={this.props.options}
        value={this.props.options[0].value}
        onChange={(value) => this.onChange(value)}
      />
    );
  }
}

export default UserHighlightsFilterControl;
